import React, { useEffect, useState } from 'react';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Nav, NavItem, NavLink, Row } from 'reactstrap';

// Componentes
import MainCard from '../../../../../components/MainCard';
import PermissoesUsuario from './PermissoesUsuario';
import Identificacao from './Identificacao';

//Helpers
import { showMessage } from '../../../../../helpers/message';

//Context
import { useAuth } from '../../../../../context/auth';

//API
import usuario_api from '../../../../../api/usuario_api';

function initialStateUsuario() {
    return {
        nome: "",
        status: "Ativo",
        email: "",
        perfil_Id: "",
    }
}

function UsuarioStepper({ id = null, handleVoltar, editavel }) {
    const { setLoading } = useAuth();

    //State de controle do passo ativo
    const [activeStep, setActiveStep] = useState(1);

    //State para criar / editar
    const [usuario, setUsuario] = useState(initialStateUsuario());

    const loadUsuarioItem = (idUsuario) => {
        if (idUsuario != null || usuario.id != null) {
            setLoading(true)
            usuario_api.getItem(idUsuario ?? usuario.id).then(response => {
                response.data.perfil_Id = response.data.perfil_Id.toString();
                setUsuario(response.data);
            }).catch(e => showMessage("Erro", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }


    useEffect(() => {
        loadUsuarioItem(id);
    }, []);


    //Função que retorna o valor do passo ativo
    const getContent = () => {
        switch (activeStep) {
            case 1:
                return <Identificacao
                    usuario={usuario}
                    setUsuario={setUsuario}
                    loadUsuarioItem={loadUsuarioItem}
                    editavel={editavel}
                />
            case 2:
                return <PermissoesUsuario
                    usuario={usuario}
                    setUsuario={setUsuario}
                    handleVoltar={handleVoltar}
                    editavel={editavel}
                />
        }
    }

    return <>
        <Button
            onClick={handleVoltar}
            className='px-4'>
            <FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar
        </Button>
        <MainCard>
            <h4 style={{ color: "#666" }}>Perfil</h4>
            <Nav tabs>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 1 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 1 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => { setActiveStep(1); }}
                    >
                        Dados de Identificação
                    </NavLink>
                </NavItem>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 2 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 2 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => {
                            if (!usuario.id) {
                                showMessage("Aviso", "Salve o usuário para fazer o controle das permissões", "info", null);
                                return;
                            }

                            setActiveStep(2);
                        }}
                    >
                        Permissões de Acesso
                    </NavLink>
                </NavItem>
            </Nav>
            <div className="mt-4">
                {getContent()}
            </div>
        </MainCard>
    </>;
}

export default UsuarioStepper;